function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
  const [from, to] = getParsed(fromInput, toInput);
  fillSlider(fromInput, toInput, "#8D9396", "#2C2F33", controlSlider);
  if (from > to) {
    fromSlider.value = to;
    fromInput.value = to;
  } else {
    fromSlider.value = from;
  }
}

function controlToInput(toSlider, fromInput, toInput, controlSlider) {
  const [from, to] = getParsed(fromInput, toInput);
  fillSlider(fromInput, toInput, "#8D9396", "#2C2F33", controlSlider);
  setToggleAccessible(toInput);
  if (from <= to) {
    toSlider.value = to;
    toInput.value = to;
  } else {
    toInput.value = from;
  }
}

function controlFromSlider(fromSlider, toSlider, fromInput) {
  const [from, to] = getParsed(fromSlider, toSlider);
  fillSlider(fromSlider, toSlider, "#8D9396", "#2C2F33", toSlider);
  if (from > to) {
    fromSlider.value = to + ".00";
    fromInput.value = to + ".00";
  } else {
    fromInput.value = from + ".00";
  }
}

function controlToSlider(fromSlider, toSlider, toInput) {
  const [from, to] = getParsed(fromSlider, toSlider);
  fillSlider(fromSlider, toSlider, "#8D9396", "#2C2F33", toSlider);
  setToggleAccessible(toSlider);
  if (from <= to) {
    toSlider.value = to + ".00";
    toInput.value = to + ".00";
  } else {
    toInput.value = from + ".00";
    toSlider.value = from + ".00";
  }
}

function getParsed(currentFrom, currentTo) {
  const from = parseInt(currentFrom.value, 10);
  const to = parseInt(currentTo.value, 10);
  return [from, to];
}

function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
  const rangeDistance = to.max - to.min;
  const fromPosition = from.value - to.min;
  const toPosition = to.value - to.min;
  controlSlider.style.background = `linear-gradient(
          to right,
          ${sliderColor} 0%,
          ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
          ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
          ${rangeColor} ${(toPosition / rangeDistance) * 100}%, 
          ${sliderColor} ${(toPosition / rangeDistance) * 100}%, 
          ${sliderColor} 100%)`;
}

function setToggleAccessible(currentTarget) {
  const toSlider = document.querySelector("#toSlider");
  if (Number(currentTarget.value) <= 0) {
    toSlider.style.zIndex = 2;
  } else {
    toSlider.style.zIndex = 0;
  }
}

const fromSlider = document.querySelector("#fromSlider");
const toSlider = document.querySelector("#toSlider");
const fromInput = document.querySelector("#fromInput");
const toInput = document.querySelector("#toInput");
fillSlider(fromSlider, toSlider, "#8D9396", "#2C2F33", toSlider);
setToggleAccessible(toSlider);

fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
fromInput.oninput = () =>
  controlFromInput(fromSlider, fromInput, toInput, toSlider);
toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);

fromSlider.oninput = () => {
  controlFromSlider(fromSlider, toSlider, fromInput);
  // Select the target input element
  const filterPriceLTEInput = document.querySelector("#price--to-min");
  filterPriceLTEInput.value = fromInput.value;
};

toSlider.oninput = () => {
  controlToSlider(fromSlider, toSlider, toInput);
  // Select the target input element
  const filterPriceLTEInput = document.querySelector("#price--to-max");
  filterPriceLTEInput.value = (parseFloat(toSlider.value) + 0.99).toFixed(2);
};

function controlFromInputMobile(
  fromSliderMobile,
  fromInputMobile,
  toInputMobile,
  controlSliderMobile
) {
  const [from, to] = getParsedMobile(fromInputMobile, toInputMobile);
  fillSliderMobile(
    fromInputMobile,
    toInputMobile,
    "#8D9396",
    "#2C2F33",
    controlSliderMobile
  );
  if (from > to) {
    fromSliderMobile.value = to;
    fromSliderMobile.value = to;
  } else {
    fromSliderMobile.value = from;
  }
}

function controlToInputMobile(
  toSliderMobile,
  fromInputMobile,
  toInputMobile,
  controlSliderMobile
) {
  const [from, to] = getParsedMobile(fromInputMobile, toInputMobile);
  fillSliderMobile(
    fromInputMobile,
    toInputMobile,
    "#8D9396",
    "#2C2F33",
    controlSliderMobile
  );
  setToggleAccessibleMobile(toInputMobile);
  if (from <= to) {
    toSliderMobile.value = to;
    toInputMobile.value = to;
  } else {
    toInputMobile.value = from;
  }
}

function controlFromSliderMobile(
  fromSliderMobile,
  toSliderMobile,
  fromInputMobile
) {
  const [from, to] = getParsedMobile(fromSliderMobile, toSliderMobile);
  fillSliderMobile(
    fromSliderMobile,
    toSliderMobile,
    "#8D9396",
    "#2C2F33",
    toSliderMobile
  );
  if (from > to) {
    fromSliderMobile.value = to + ".00";
    fromInputMobile.value = to + ".00";
  } else {
    fromInputMobile.value = from + ".00";
  }
}

function controlToSliderMobile(
  fromSliderMobile,
  toSliderMobile,
  toInputMobile
) {
  const [from, to] = getParsedMobile(fromSliderMobile, toSliderMobile);
  fillSliderMobile(fromSlider, toSlider, "#8D9396", "#2C2F33", toSlider);
  setToggleAccessibleMobile(toSliderMobile);
  if (from <= to) {
    toSliderMobile.value = to + ".00";
    toInputMobile.value = to + ".00";
  } else {
    toInputMobile.value = from + ".00";
    toSliderMobile.value = from + ".00";
  }
}

function getParsedMobile(currentFromMobile, currentToMobile) {
  const from = parseInt(currentFromMobile.value, 10);
  const to = parseInt(currentToMobile.value, 10);
  return [from, to];
}

function fillSliderMobile(
  from,
  to,
  sliderColorMobile,
  rangeColorMobile,
  controlSliderMobile
) {
  const rangeDistanceMobile = to.max - to.min;
  const fromPositionMobile = from.value - to.min;
  const toPositionMobile = to.value - to.min;
  controlSliderMobile.style.background = `linear-gradient(
          to right,
          ${sliderColorMobile} 0%,
          ${sliderColorMobile} ${
    (fromPositionMobile / rangeDistanceMobile) * 100
  }%,
          ${rangeColorMobile} ${
    (fromPositionMobile / rangeDistanceMobile) * 100
  }%,
          ${rangeColorMobile} ${
    (toPositionMobile / rangeDistanceMobile) * 100
  }%, 
          ${sliderColorMobile} ${
    (toPositionMobile / rangeDistanceMobile) * 100
  }%, 
          ${sliderColorMobile} 100%)`;
}

function setToggleAccessibleMobile(currentTarget) {
  const toSliderMobile = document.querySelector("#toSlider");
  if (Number(currentTarget.value) <= 0) {
    toSliderMobile.style.zIndex = 2;
  } else {
    toSliderMobile.style.zIndex = 0;
  }
}

//
const fromSliderMobile = document.querySelector("#fromSliderMobile");
const toSliderMobile = document.querySelector("#toSliderMobile");
const fromInputMobile = document.querySelector("#fromInputMobile");
const toInputMobile = document.querySelector("#toInputMobile");
fillSlider(
  fromSliderMobile,
  toSliderMobile,
  "#8D9396",
  "#2C2F33",
  toSliderMobile
);
setToggleAccessible(toSliderMobile);

fromSliderMobile.oninput = () =>
  controlFromSliderMobile(fromSliderMobile, toSliderMobile, fromInputMobile);
toSliderMobile.oninput = () =>
  controlToSliderMobile(fromSliderMobile, toSliderMobile, toInputMobile);
fromInputMobile.oninput = () =>
  controlFromInput(
    fromSliderMobile,
    fromInputMobile,
    toInputMobile,
    toSliderMobile
  );
toInputMobile.oninput = () =>
  controlToInputMobile(
    toSliderMobile,
    fromInputMobile,
    toInputMobile,
    toSliderMobile
  );

fromSliderMobile.oninput = () => {
  controlFromSliderMobile(fromSliderMobile, toSliderMobile, fromInputMobile);
  // Select the target input element
  const filterPriceLTEInputMobile = document.querySelector(
    "#price--to-min-mobile"
  );
  filterPriceLTEInputMobile.value = fromInputMobile.value;
};

toSliderMobile.oninput = () => {
  controlToSliderMobile(fromSliderMobile, toSliderMobile, toInputMobile);
  // Select the target input element
  const filterPriceLTEInputMobile = document.querySelector(
    "#price--to-max-mobile"
  );
  filterPriceLTEInputMobile.value = (
    parseFloat(toSliderMobile.value) + 0.99
  ).toFixed(2);
};
